export default {
  alt: '选择语言',
  en: {
    alt: '英语',
    title: '英语',
  },
  es: {
    alt: '西班牙语',
    title: '西班牙语',
  },
  close: {
    alt: '关闭',
  },
  ko: {
    alt: '韩语',
    title: '韩语',
  },
  zh: {
    alt: '中文',
    title: '中文',
  },
  vi: {
    alt: '越南语',
    title: '越南语',
  },
  ru: {
    alt: '俄语',
    title: '俄语',
  },
}
